import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout/Layout.vue'
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
}

Vue.use(VueRouter)
    /**
     * 
     * hidden  //是否需要隐藏标题栏 true 隐藏 
     * hiddenBack  //是否需要隐藏返回按钮 true 隐藏 
     */

const routes = [{
        path: '/login',
        name: 'login',
        component: () =>
            import ('../views/Login/Login.vue'),
        meta: {
            hidden: true,
            title: '登录'
        }
    },
    {
        path: '/forget',
        name: 'forget',
        component: () =>
            import ('../views/Login/Forget.vue'),
        meta: {
            title: '重置密码'
        }
    },
    {
        path: '/userRegister',
        name: 'userRegister',
        component: () =>
            import ('../views/Login/UserRegister.vue'),
        meta: {
            title: '新用户注册'
        }
    },


    /**
     * 8888888888888888888888888888888888888888888888888888888888888888这里是---主屏----开始
     */
    {
        path: '/',
        name: 'i',
        component: Layout,
        redirect: '/open',
        children: [
            // 功能收银模块
            {
                path: '/open',
                name: 'open',
                redirect: '/open/index',
                component: () => import ('../views/Work/open/openLayout.vue'),
                children:[{
                    path: '/open/index',
                    name: 'open_index',
                    component: () =>
                        import ('../views/Work/open/openIndex.vue'),
                    meta: {
                        title: '开单收银',
                    }
                }]
            },
            // 订单管理模块
            {
                path: '/order',
                name: 'order',
                redirect: '/order/index',
                component: () => import ('../views/Work/order/orderLayout.vue'),
                children:[{
                    path: '/order/index',
                    name: 'order_index',
                    component: () =>
                        import ('../views/Work/order/orderIndex.vue'),
                    meta: {
                        title: '订单管理',
                    }
                }]
            },
            // 库存管理模块
            {
                path: '/stock',
                name: 'stock',
                redirect: '/stock/index',
                component: () => import ('../views/Work/stock/stockLayout.vue'),
                children:[{
                    path: '/stock/index',
                    name: 'stock_index',
                    component: () =>
                        import ('../views/Work/stock/stockIndex.vue'),
                    meta: {
                        title: '库存管理',
                    }
                },{
                    path: '/stock/dataGoods',
                    name: 'stock_dataGoods',
                    component: () =>
                        import ('../views/Work/stock/dataGoods.vue'),
                    meta: {
                        title: '变更记录',
                    }
                },{
                    path: '/stock/dataFee',
                    name: 'stock_dataFee',
                    component: () =>
                        import ('../views/Work/stock/dataFee.vue'),
                    meta: {
                        title: '费用统计',
                    }
                },]
            },
            // 货主管理模块
            {
                path: '/owner',
                name: 'owner',
                redirect: '/owner/index',
                component: () => import ('../views/Work/owner/ownerLayout.vue'),
                children:[{
                    path: '/owner/index',
                    name: 'owner_index',
                    component: () =>
                        import ('../views/Work/owner/ownerIndex.vue'),
                    meta: {
                        title: '货主管理',
                    }
                }]
            },
            // 买家管理模块
            {
                path: '/buyer',
                name: 'buyer',
                redirect: '/buyer/index',
                component: () => import ('../views/Work/buyer/buyerLayout.vue'),
                children:[{
                    path: '/buyer/index',
                    name: 'buyer_index',
                    component: () =>
                        import ('../views/Work/buyer/buyerIndex.vue'),
                    meta: {
                        title: '买家管理',
                    }
                },
                {
                    path: '/buyer/detail',
                    name: 'buyer_detail',
                    component: () =>
                        import ('../views/Work/buyer/buyerDetail.vue'),
                    meta: {
                        title: '买家详情',
                    }
                }]
            },
            
            // 数据统计模块
            {
                path: '/data',
                name: 'data',
                redirect: '/data/index',
                component: () => import ('../views/Work/data/dataLayout.vue'),
                children:[
                    {
                    path: '/data/index',
                    name: 'data_index',
                    component: () =>
                        import ('../views/Work/data/dataIndex.vue'),
                    meta: {
                        title: '报表统计',
                    },

                    
                },
                {
                    path: '/data/goodsAcount/goodsAcountDetail',
                    name: 'goodsAcountDetail',
                    component: () =>
                        import ('../views/Work/data/saleAcountPart/goodsAcountDetail.vue'),
                    meta: {
                        title: '商品统计详情',
                    }
                },
                {
                    path: '/data/todayAcount/todayAcountDetail',
                    name: 'todayAcountDetail',
                    component: () =>
                        import ('../views/Work/data/todayAcountPart/todayAcountDetail.vue'),
                    meta: {
                        title: '今日统计详情',
                    }
                },
                {
                    path: '/data/todayAcount/netReceiptsAcount',
                    name: 'netReceiptsAcount',
                    component: () =>
                        import ('../views/Work/data/todayAcountPart/netReceiptsAcount.vue'),
                    meta: {
                        title: '日实收统计',
                    }
                },
                {
                    path: '/data/customerAcount/customerAcountDetail',
                    name: 'customerAcountDetail',
                    component: () =>
                        import ('../views/Work/data/saleAcountPart/customerAcountDetail.vue'),
                    meta: {
                        title: '客户统计详情',
                    }
                },
                {
                    path: '/data/customerAcount/customerAcountDetail/goodsDetail',
                    name: 'customerAcountDetail_goodsDetail',
                    component: () =>
                        import ('../views/Work/data/saleAcountPart/customerAcountDetail_goodsDetail.vue'),
                    meta: {
                        title: '客户统计详情商品详情',
                    }
                },
                {
                    path: '/data/creditAcountPart/creditAcountDetail',
                    name: 'creditAcountDetail',
                    component: () =>
                        import ('../views/Work/data/creditAcountPart/creditAcountDetail.vue'),
                    meta: {
                        title: '赊欠统计详情',
                    }
                },
                {
                    path: '/data/batchAcountDetail',
                    name: 'batchAcountDetail',
                    component: () =>
                        import ('../views/Work/data/saleAcountPart/batchAcountDetail.vue'),
                    meta: {
                        title: '批次统计详情',
                    }
                },
                {
                    path: '/data/batchAcountDetail/batchAcountGoodsDetail',
                    name: 'batchAcountGoodsDetail',
                    component: () =>
                        import ('../views/Work/data/saleAcountPart/batchAcountDetail_goodsDetail.vue'),
                    meta: {
                        title: '批次统计详情商品详情',
                    }
                },

            ]
            },
            // 个人中心
            {
                path: '/personal',
                name: 'personal',
                redirect: '/personal/index',
                component: () => import ('../views/Work/personal/personalLayout.vue'),
                children:[{
                    path: '/personal/index',
                    name: 'personal_index',
                    component: () =>
                        import ('../views/Work/personal/personalIndex.vue'),
                    meta: {
                        title: '个人中心',
                    }
                },
                {
                    path: '/personal/forget',
                    name: 'personal_forget',
                    component: () =>
                        import ('../views/Login/Forget.vue'),
                    meta: {
                        title: '重置密码'
                    }
                },]
            },
            
            
            {
                path: '/public/scan',
                name: 'public_scan',
                component: () =>
                    import ('../views/Public/scan.vue'),
                meta: {
                    title: '扫一扫',
                    hidden: true,
                }

            },
        ]
    },
    /**
     * 8888888888888888888888888888888888888888888888888888888888888888这里是---主屏----结束
     */

     

]


const router = new VueRouter({
    // mode: 'history' ,
    routes,
    scrollBehavior(to, from, savedPssition) {
        if (savedPssition) {
            return savedPssition;
        } else {
            return { x: 0, y: 0 }
        }
    }
})

export default router